// LOGOUT
import jwt_decode from "jwt-decode";
import {setLoginScreenStatus} from "../../helpers/index.js";
import {clearProfilePhotoCache} from "../../hooks/useProfilePhoto.js";

let navigateToLogin = null;

export const logout = () => {
    sessionStorage.clear();
    localStorage.clear();
    clearProfilePhotoCache();
}

export const registerAuthNavigator = (navigate) => {
    navigateToLogin = navigate;
}

export const forceLogout = (dispatch) => {
    logout();
    setLoginScreenStatus(true);

    if (dispatch) {
        dispatch({
            type: 'RESET'
        });
    }

    if (typeof navigateToLogin === 'function') {
        navigateToLogin('/login');
    }
}

function isEmptyObject(obj) {
    return obj !== null && typeof obj === 'object' && Object.keys(obj).length === 0;
}


// LOGIN STATUS
export const isLogin = (dispatch) => {
    const userStr = sessionStorage.getItem('user') || localStorage.getItem('user');
    let token = JSON.parse(userStr && userStr !== 'undefined' && userStr !== 'null' ? userStr : '{}')

    if (isEmptyObject(token))
        token = null;

    if (!token || jwt_decode(token).exp < Date.now() / 1000) {
        forceLogout(dispatch);
        return false;
    }

    const expiresIn = sessionStorage.getItem("expiresIn") || localStorage.getItem("expiresIn");
    return expiresIn && token && jwt_decode(token).exp > Date.now() / 1000;
}
